module.exports = __webpack_public_path__ + "img/lea.34a66d27.jpg";